import { BentoColumn, BentoColumnProps } from '../../components/Bento/Bento'
import { createWidget } from '../widget-utils'

export const BentoColumnWidget = ({
  isLoading,
  ...props
}: BentoColumnProps & { isLoading?: boolean }) => <BentoColumn {...props} />

export const BentoColumnWidgetDefinition = createWidget(BentoColumnWidget, {
  type: 'BentoColumn',
})
